import {currentPageTypes, keyVal} from '../actions/current-page'

const initialState = {
    prev_page: 'dashboard',
    current_page: 'dashboard',
    admin_gbn: '2',
    open_tabs: [] as string[]
}

type currentPageState = typeof initialState

/* reducer */
const currentPage = (state: currentPageState = initialState, action: currentPageTypes): currentPageState => {

    if(keyVal.findIndex(element => action.type === element) === -1)
        return state

    if(action.type === 'currentPage/LOGOUT')
        return initialState

    if(action.type === 'currentPage/RESETCHANGE')
        return { ...state, current_page: state.prev_page }

    if (action.type === 'currentPage/SETADMINGBN') {

        return {...state, admin_gbn: action.payload }
    }

    if (action.type === 'currentPage/REMOVETAB') {
        const tabToRemove = action.payload;
        const newOpenTabs = state.open_tabs.filter(tab => tab !== tabToRemove);
        let nextCurrentPage = state.current_page;
        
        if (state.current_page === tabToRemove) {
            // If we closed the active tab, switch to the last available tab, or dashboard if none
            nextCurrentPage = newOpenTabs.length > 0 ? newOpenTabs[newOpenTabs.length - 1] : 'dashboard';
        }

        return { ...state, open_tabs: newOpenTabs, current_page: nextCurrentPage };
    }

    const newPage = action.payload;
    let newOpenTabs = state.open_tabs;

    if (newPage && typeof newPage === 'string' && newPage !== 'dashboard' && newPage !== 'reset-change') {
        if (!newOpenTabs.includes(newPage)) {
            newOpenTabs = [...newOpenTabs, newPage];
        }
    }

    return { ...state, prev_page: state.current_page, current_page: newPage, open_tabs: newOpenTabs }
}

export default currentPage